<form *ngIf="user.contactDetails" autocomplete="off" class="mt-3 pt-3">
    <div class="form-group">
        <label for="Staff_FirstName">{{ l("FirstName") }}</label>
        <input
            type="text"
            id="Staff_FirstName"
            class="form-control"
            [(ngModel)]="user.contactDetails.firstName"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            required
            #firstName="ngModel"
            name="FirstName"
        />

        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="invalid">
            <div *ngIf="firstName.errors.required">
                {{ l('FirstNameIsRequired') }}
            </div>
        </div>
    </div>

    <div class="form-group">
        <label for="Staff_LastName">{{ l("LastName") }}</label>
        <input
            type="text"
            id="Staff_LastName"
            class="form-control"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            [(ngModel)]="user.contactDetails.lastName"
            required
            #lastName="ngModel"
            name="LastName"
        />

        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="invalid">
            <div *ngIf="lastName.errors.required">
                {{ l('LastNameIsRequired') }}
            </div>
        </div>

    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_BirthDate">{{ l("BirthDate") }}</label>
        <input
            class="form-control m-input"
            type="datetime"
            bsDatepicker
            datePickerMomentModifier
            [(date)]="user.biositeStaffDetails.birthDate"
            id="Staff_BirthDate"
            name="Staff_BirthDate"
            [disabled]="true"
        />
    </div>

    <div class="form-group">
        <label for="Staff_EmailAddress">{{ l("EmailAddress") }}</label>
        <input
            type="text"
            id="Staff_EmailAddress"
            class="form-control"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            [(ngModel)]="user.contactDetails.emailAddress"
            name="EmailAddress"
            #email="ngModel"
            pattern="[a-z0-9._'%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
            required
        />
        <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid">
            <div *ngIf="email.errors.required">
                {{ l('EmailIsRequired') }}
            </div>
            <div *ngIf="email.errors.pattern">
                {{ l('InvalidEmail') }}
            </div>
        </div>
    </div>

    <div class="form-group">
        <label for="Staff_ContactNumber">{{ l("ContactNumber") }}</label>
        <input
            type="text"
            id="Staff_ContactNumber"
            class="form-control"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            [(ngModel)]="user.contactDetails.contactNumber"
            name="ContactNumber"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_bioSiteId">{{ l("BioSiteId") }}</label>
        <input
            type="text"
            id="Staff_bioSiteId"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.biositeId"
            [disabled]="true"
            name="bioSiteId"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_bioSiteId">{{ l("GaneTimeId") }}</label>
        <input
            type="text"
            id="ganeTimeId"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.ganeTimeId"
            [disabled]="true"
            name="ganeTimeId"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_bioSiteId">{{ l("ePloyId") }}</label>
        <input
            type="text"
            id="ePloyId"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.ePloyId"
            [disabled]="true"
            name="ePloyId"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_bioSiteId">{{ l("UserGroup") }}</label>
        <input
            type="text"
            id="userGroup"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.userGroup"
            [disabled]="true"
            name="userGroup"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_bioSiteId">{{ l("HS2JobTitle") }}</label>
        <input
            type="text"
            id="hs2jobTitle"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.hS2JobTitle"
            [disabled]="true"
            name="hs2jobTitle"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_JobRole">{{ l("JobRole") }}</label>
        <input
            type="text"
            id="Staff_JobRole"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.jobRole"
            [disabled]="true"
            name="JobRole"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_operatingLevel">{{ l("OperatingLevel") }}</label>
        <input
            type="text"
            id="Staff_operatingLevel"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.operatingLevel"
            [disabled]="true"
            name="operatingLevel"
        />
    </div>

    <div
        class="form-group"
        *ngIf="
            isSupervisorOrForeman(user.staffUserRole) ||
            isProjectAdministrator(user.staffUserRole)
        "
    >
        <label for="Staff_MainWorkLocation">{{ l("MainWorkLocation") }}</label>
        <input
            type="text"
            id="Staff_MainWorkLocation"
            class="form-control"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            [(ngModel)]="user.workDetails.mainWorkLocation"
            name="MainWorkLocation"
        />
    </div>

    <div
        class="form-group"
        *ngIf="
            isSupervisorOrForeman(user.staffUserRole) ||
            isProjectAdministrator(user.staffUserRole)
        "
    >
        <label for="Staff_biositeManagerName">{{
            l("BioSiteManagerName")
            }}</label>
        <input
            type="text"
            id="Staff_biositeManagerName"
            class="form-control"
            [(ngModel)]="user.workDetails.managerName"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            name="Staff_biositeManagerName"
        />
    </div>

    <div
        class="form-group"
        *ngIf="
            isSupervisorOrForeman(user.staffUserRole) ||
            isProjectAdministrator(user.staffUserRole)
        "
    >
        <label for="Staff_biositeManagerEmail">{{
            l("BioSiteManagerEmail")
            }}</label>
        <input
            type="text"
            id="Staff_biositeManagerEmail"
            class="form-control"
            [(ngModel)]="user.workDetails.managerEmail"
            [disabled]="isSupervisorOrForeman(user.staffUserRole)"
            name="Staff_biositeManagerEmail"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_empCompany">{{ l("EmployingCompany") }}</label>
        <input
            type="text"
            id="Staff_empCompany"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.employingCompany"
            [disabled]="true"
            name="Staff_empCompany"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_subCompany">{{
            l("SubcontractorEmployingCompany")
            }}</label>
        <input
            type="text"
            id="Staff_subCompany"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.subcontractorEmployingCompany"
            [disabled]="true"
            name="Staff_subCompany"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_startDate">{{ l("StartDate") }}</label>
        <input
            type="text"
            id="Staff_startDate"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.startDate"
            [disabled]="true"
            name="Staff_startDate"
        />
    </div>

    <div class="form-group" *ngIf="isSupervisorOrForeman(user.staffUserRole)">
        <label for="Staff_endDate">{{ l("EndDate") }}</label>
        <input
            type="text"
            id="Staff_endDate"
            class="form-control"
            [(ngModel)]="user.biositeStaffDetails.endDate"
            [disabled]="true"
            name="Staff_endDate"
        />
    </div>

    <div class="form-group" *ngIf="isGranted('Pages.Role.Supervisor')">
        <label for="UserName">{{ l("AlloSignOff") }}</label>
        <div class="input-group">
            <input
                class="form-control"
                id="UserName"
                name="userName"
                [(ngModel)]="signOffPerson"
                type="text"
                disabled
            />
            <div class="input-group-append">
                <button
                    class="btn btn-primary blue"
                    (click)="openSelectUserModal()"
                    type="button">
                    <i class="fa fa-search"
                    data-toggle="popover"
                    data-trigger="hover"
                    data-html="true"
                    [popover]="popTemplate"
                    triggers="mouseenter:mouseleave"></i>
                    <ng-template #popTemplate>
                        <div class="tooltip-div">{{ l('SelectaManager') }}</div>
                    </ng-template>
                    {{ l("Pick") }}
                </button>
            </div>
            <div class="input-group-prepend">
                <button
                    class="btn btn-danger btn-icon"
                    type="button"
                    (click)="setUserIdNull()"
                >
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>
    </div>

    <ng-container>
        <div class="col-lg-12">
            <button
                (click)="save()"
                class="btn btn-primary blue float-right"
                [buttonBusy]="saving"
                [busyText]="l('SavingWithThreeDot')"
                [disabled]="isSupervisor(user.staffUserRole) && !signOffPerson || firstName.invalid || lastName.invalid || email.invalid">
                <i class="fa fa-save"></i>
                <span>{{ l("Save") }}</span>
            </button>

            <button
                *ngIf="
                    isGrantedAny('Pages.Administration.Users.Edit') &&
                    !ownDetailsEdit
                "
                (click)="sendEmailActivationLink()"
                [busyText]="l('SavingWithThreeDot')"
                [buttonBusy]="saving"
                class="mr-5 btn btn-primary blue float-right"
            >
                <i class="fa fa-envelope-square"></i>
                <span>{{ l("SendEmailActivationLink") }}</span>
            </button>
        </div>
    </ng-container>

    <div
        *ngIf="
            isGrantedAny('Pages.Administration.Users.Edit') && !ownDetailsEdit
        "
        class="change-password-container"
    >
        <h3>{{ l("ChangeUserPassword") }}</h3>

        <input type="password" style="display: none"/>

        <div class="form-group">
            <label for="Password">{{ l("Password") }}</label>
            <input
                #Password="ngModel"
                [(ngModel)]="newPassword"
                [requireDigit]="passwordComplexitySetting.requireDigit"
                [requiredLength]="passwordComplexitySetting.requiredLength"
                [requireLowercase]="passwordComplexitySetting.requireLowercase"
                [requireNonAlphanumeric]="
                    passwordComplexitySetting.requireNonAlphanumeric
                "
                [requireUppercase]="passwordComplexitySetting.requireUppercase"
                autocomplete="off"
                class="form-control"
                id="Password"
                name="Password"
                pPassword
                required
                type="password"
            />
        </div>

        <div [hidden]="Password.valid || Password.pristine" class="form-group">
            <ul class="form-text text-danger" *ngIf="Password.errors">
                <li [hidden]="!Password.errors.requireDigit">
                    {{ "PasswordComplexity_RequireDigit_Hint" | localize }}
                </li>
                <li [hidden]="!Password.errors.requireLowercase">
                    {{ "PasswordComplexity_RequireLowercase_Hint" | localize }}
                </li>
                <li [hidden]="!Password.errors.requireUppercase">
                    {{ "PasswordComplexity_RequireUppercase_Hint" | localize }}
                </li>
                <li [hidden]="!Password.errors.requireNonAlphanumeric">
                    {{
                    "PasswordComplexity_RequireNonAlphanumeric_Hint"
                        | localize
                    }}
                </li>
                <li [hidden]="!Password.errors.requiredLength">
                    {{
                    "PasswordComplexity_RequiredLength_Hint"
                        | localize: passwordComplexitySetting.requiredLength
                    }}
                </li>
            </ul>
        </div>

        <div class="col-lg-12">
            <button
                (click)="changeUserPassword()"
                [busyText]="l('SavingWithThreeDot')"
                [disabled]="Password.errors"
                [buttonBusy]="saving"
                class="btn btn-primary blue float-right"
            >
                <i class="fa fa-key"></i>
                <span>{{ l("ChangePassword") }}</span>
            </button>
        </div>
        
    </div>
    


</form>

<staffUserLookupTableModal
    #staffUserLookupTableModal
    (modalSave)="getSelectedUser()"
>
</staffUserLookupTableModal>
